export default "/images/8028e8f22e964616892cc5318d7c743e.png";